import './Button.less';
import { IconId } from '../icon/icons';
import Icon from '../icon/Icon';
import { forwardRef, type PropsWithChildren } from 'preact/compat';

export type ButtonSize = 'small' | 'medium' | 'large';

export type ButtonProps = PropsWithChildren<{
    variant:
        | 'link'
        | 'primary'
        | 'secondary'
        | 'tertiary'
        | 'white'
        | 'magic'
        | 'text'
        | 'glass';
    endIconId?: IconId;
    endIconSize?: 'x-small' | 'medium' | 'x-large';
    startIconId?: IconId;
    startIconSize?: 'x-small' | 'small' | 'medium' | 'x-large';
    disabled?: boolean;
    onClick?: (event: MouseEvent) => void;
    className?: string;
    active?: boolean;
    size?: ButtonSize;
    fullWidth?: boolean;
    title?: string;
}>;

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
    (
        {
            title,
            children,
            variant = 'white',
            endIconId,
            endIconSize,
            startIconId,
            startIconSize,
            onClick,
            disabled,
            className = '',
            active,
            size = 'medium',
            fullWidth = false
        },
        ref
    ) => (
        <button
            type="button"
            title={title}
            disabled={disabled}
            className={`bri-Button bri-BodyFont bri-Button-variant-${variant} bri-Button-${size} ${disabled ? 'bri-Button-disabled' : ''} ${active ? 'bri-active' : ''} ${fullWidth ? 'bri-Button-full-width' : ''}  ${className}`}
            onClick={onClick}
            ref={ref}
        >
            {startIconId && (
                <Icon
                    className="bri-Button-start-icon"
                    iconId={startIconId}
                    size={startIconSize}
                />
            )}
            <span>{children}</span>
            {endIconId && (
                <Icon
                    className="bri-Button-end-icon"
                    iconId={endIconId}
                    size={endIconSize}
                />
            )}
        </button>
    )
);

export default Button;
